import * as packageManifest from '../../package.json';
import { definition as collectionCaptureAnnotationsDefinition } from './endpoints/public/collection/collection.capture.annotations.get.schema';
import { definition as collectionDefinition } from './endpoints/public/collection/collection.get.schema';
import { definition as collectionsDefinition } from './endpoints/public/collection/collection.list.get.schema';
import { definition as departmentDefinition } from './endpoints/public/department/department.get.schema';
import { definition as departmentsDefinition } from './endpoints/public/department/department.list.get.schema';
import { definition as formDefinition } from './endpoints/public/form/form.get.schema';
import { definition as formsDefinition } from './endpoints/public/form/form.list.get.schema';
import { definition as jobsDefinition } from './endpoints/public/job/job.get.schema';
import { definition as jobDefinition } from './endpoints/public/job/job.list.get.schema';

const port = process.env.PORT || '1337';
const PUBLIC = {
	...departmentsDefinition,
	...departmentDefinition,
	...formsDefinition,
	...formDefinition,
	...jobsDefinition,
	...jobDefinition,
	...collectionsDefinition,
	...collectionDefinition,
	...collectionCaptureAnnotationsDefinition,
};
const INTERNAL = {};
export const makeSwaggerDocument = ({
	publicOnly,
}: {
	publicOnly?: boolean;
} = {}) => ({
	openapi: '3.0.0',
	components: {
		securitySchemes: {
			BearerAuth: {
				type: 'http',
				scheme: 'bearer',
				name: 'Authorization',
				bearerFormat: 'JWT',
			},
		},
		parameters: {
			ikeRequester: {
				name: 'X-Ike-Requester',
				in: 'header',
				description: 'A name to indicate who / where the request is originating from',
				required: true,
				schema: {
					type: 'string',
					default: 'Swagger',
					enum: ['Swagger'],
				},
			},
			ikeDepartmentId: {
				name: 'X-Ike-Department-Id',
				in: 'header',
				description: 'The ID of the department you wish to query from',
				required: true,
				schema: {
					type: 'string',
				},
			},
			departmentIdPath: {
				name: 'department_id',
				in: 'path',
				description: 'The ID of the department you wish to query for',
				required: true,
				schema: {
					type: 'string',
				},
			},
			formIdPath: {
				name: 'form_id',
				in: 'path',
				description: 'The ID of the form you wish to query for',
				required: true,
				schema: {
					type: 'string',
				},
			},
			jobIdPath: {
				name: 'job_id',
				in: 'path',
				description: 'The ID of the job you wish to query for',
				required: true,
				schema: {
					type: 'string',
				},
			},
			collectionIdPath: {
				name: 'collection_id',
				in: 'path',
				description: 'The ID of the collection you wish to query for',
				required: true,
				schema: {
					type: 'string',
				},
			},
			collectionIdQuery: {
				name: 'collectionId',
				in: 'query',
				description:
					'The ID of the collection containing the capture, as carried by backbone event payloads. Provide exactly one of collectionId and collectionUuid.',
				required: false,
				schema: {
					type: 'string',
				},
			},
			collectionUuidQuery: {
				name: 'collectionUuid',
				in: 'query',
				description:
					'The UUID of the collection containing the capture. Provide exactly one of collectionId and collectionUuid.',
				required: false,
				schema: {
					type: 'string',
				},
			},
			captureIdQuery: {
				name: 'captureId',
				in: 'query',
				description: 'The ID of the capture to render annotations for',
				required: true,
				schema: {
					type: 'string',
				},
			},
			timezoneQuery: {
				name: 'timezone',
				in: 'query',
				description: 'IANA timezone name used when rendering timestamps. Defaults to UTC.',
				required: false,
				schema: {
					type: 'string',
					default: 'UTC',
				},
			},
			unitsQuery: {
				name: 'units',
				in: 'query',
				description: 'Distance units used when rendering measurements. Defaults to feet.',
				required: false,
				schema: {
					type: 'string',
					enum: ['feet', 'meters'],
					default: 'feet',
				},
			},
		},
	},
	security: [
		{
			BearerAuth: [],
		},
	],
	info: {
		title: 'Ike Office API',
		version: packageManifest.version,
		description: 'The private and public API endpoints for the Ike Office API',
	},
	servers: [
		{
			url: 'https://automation.office.ikegps.net',
			description: 'Automation Environment',
		},
		{
			url: `http://localhost:${port}/v1`,
			description: 'Local server',
		},
		{
			url: 'https://test.office.ikegps.net',
			description: 'Test Environment',
		},
		{
			url: 'https://test2.office.ikegps.net',
			description: 'Test 2 Environment',
		},
		{
			url: 'https://staging.office.ikegps.net',
			description: 'Staging Environment',
		},
		{
			url: 'https://office.ikegps.com',
			description: 'Production Environment',
		},
	],
	paths: {
		...(publicOnly ? undefined : INTERNAL),
		...PUBLIC,
	},
});
export const swaggerDocument = makeSwaggerDocument();
export const swaggerPublicDocument = makeSwaggerDocument({
	publicOnly: true,
});
